import { NextStepNotFound, PreviousStepNotFound, StepNotFound } from './errors';

class StepCollection {
  constructor(steps = []) {
    this._steps = steps;
  }

  find(name) {
    const step = this._steps.find(item => item.name === name);

    if (!step) {
      throw new StepNotFound(name);
    }

    return step;
  }

  findNext(name) {
    const currentStepIndex = this._getIndexOfStepByName(name);

    if (!this._steps[currentStepIndex + 1]) {
      throw new NextStepNotFound(name);
    }

    return this._steps[currentStepIndex + 1];
  }

  findPrevious(name) {
    const currentStepIndex = this._getIndexOfStepByName(name);

    if (!this._steps[currentStepIndex - 1]) {
      throw new PreviousStepNotFound(name);
    }

    return this._steps[currentStepIndex - 1];
  }

  getOrderedByName() {
    const stepsNames = [];

    this._steps.forEach(step => {
      stepsNames.push(step.name);
    });

    return stepsNames;
  }

  _getIndexOfStepByName(name) {
    const step = this.find(name);

    return this._steps.indexOf(step);
  }
}

export default StepCollection;
